export default __webpack_public_path__ + "static/media/fox-bg.fb902e51.jpg";